<div class="jumbotron text-center">
  <div class="container">
    <div class="row">
      <div class="col-sm-6" style="text-align:left">
        <button type="button" class="btn btn-outline-primary" (click)="open(content)">Create New
        Patient</button>
      </div>
      <div class="col-sm-6">
        <div class="search-wrap">
          <input class="form-control" type="text" placeholder="Search by name, number, or phone..."
            [(ngModel)]="PatientName" (ngModelChange)="onSearchChange()">
          @if (PatientName) {
            <button type="button" class="btn btn-sm btn-outline-secondary"
            (click)="clearSearch()">Clear</button>
          }
        </div>
      </div>
    </div>
    <br>
      @if (this.api.canEnter(['admin', 'staff', 'accountant', 'doctor'])) {
        <div class="row">
          <div class="col-sm-12">
            <div class="table-responsive patients-table-wrap">
              <table class="table table-bordered table-hover align-middle patients-table" id="excel-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th colspan="2"><a class="sortable-link" (click)="sort('name')">Name</a></th>
                    <th>ID</th>
                    <th>Gender</th>
                    <th>Patient Age</th>
                    <th>Phone</th>
                    <th>Secondary Phone</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  @if (filteredItems.length == 0) {
                    <tr class="empty-row">
                      <td colspan="9">No Data Found.</td>
                    </tr>
                  }
                  @for (item of filteredItems | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize; track item; let i = $index) {
                    <tr
                      >
                      <td>{{ ((page-1) * pageSize) + (i+1) }}</td>
                      <td>
                        <a class="patient-link" href="#" [routerLink]="['/patient_details']" [queryParams]="{ id: item?.id }">{{item?.patient_number}}
                        </a>
                      </td>
                      <td class="text-start">
                        {{item?.first_name}} {{item?.last_name}}
                      </td>
                      <td>{{item?.national_id}}</td>
                      <td>{{item?.gender}}</td>
                      <td>
                        {{item?.age}} @if (item?.age) {
                        <small>years old</small>
                      }
                    </td>
                    <td>{{item?.phone}}</td>
                    <td>{{item?.phone2}}</td>
                    <td class="actions-cell">
                      <div class="btn-group mr-2 btn-group-sm" role="group" aria-label="First group"
                        dir="auto">
                        <button [disabled]="!utility.isAllowed(['admin', 'accountant', 'doctor'])" type="button" class="btn btn-danger"
                          (click)="onDelete(item?.id)">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                            fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                            <path
                              d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                            <path fill-rule="evenodd"
                              d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" />
                          </svg>
                        </button>
                        <button type="button" class="btn btn-secondary" (click)="edit(content2, item)">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                            fill="currentColor" class="bi bi-pencil-square" viewBox="0 0 16 16">
                            <path
                              d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                            <path fill-rule="evenodd"
                              d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z" />
                          </svg>
                        </button>
                        <!-- <button type="button" class="btn btn-success"
                        (click)="open(contentAppointment, item.id)">
                        <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24"
                          height="24px" viewBox="0 0 24 24" width="24px" fill="#ffffff">
                          <g>
                            <rect fill="none" height="24" width="24" />
                            <rect fill="none" height="24" width="24" />
                          </g>
                          <g>
                            <g>
                              <polygon
                                points="22,9 22,7 20,7 20,9 18,9 18,11 20,11 20,13 22,13 22,11 24,11 24,9" />
                              <path
                                d="M8,12c2.21,0,4-1.79,4-4s-1.79-4-4-4S4,5.79,4,8S5.79,12,8,12z" />
                              <path
                                d="M8,13c-2.67,0-8,1.34-8,4v3h16v-3C16,14.34,10.67,13,8,13z" />
                              <path
                                d="M12.51,4.05C13.43,5.11,14,6.49,14,8s-0.57,2.89-1.49,3.95C14.47,11.7,16,10.04,16,8S14.47,4.3,12.51,4.05z" />
                              <path
                                d="M16.53,13.83C17.42,14.66,18,15.7,18,17v3h2v-3C20,15.55,18.41,14.49,16.53,13.83z" />
                            </g>
                          </g>
                        </svg>
                      </button> -->
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
        <br>
          <ngb-pagination class="mt-3" [collectionSize]="filteredItems.length" [(page)]="page" [maxSize]="5" [rotate]="true"
          [ellipses]="false" [boundaryLinks]="false"></ngb-pagination>
          <div class="mt-2 text-start text-muted">
            Showing {{ filteredItems.length }} of {{ list_length }} patients
          </div>
        </div>
      </div>
    }

    <div class="row">
      <ng-template #content let-modal>
        <div class="modal-header">
          <h4 class="modal-title" id="modal-basic-title">New Patient</h4>
          <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <div class="row">
              <div class="col">
                <label for="first_name" class="form-label">Name <span class="text-danger">*</span></label>
                <input type="text" class="form-control" [(ngModel)]="item.first_name" id="first_name" required>
              </div>
              <div class="col">
                <label for="last_name" class="form-label">Last Name <span class="text-danger">*</span></label>
                <input type="text" class="form-control" [(ngModel)]="item.last_name" id="last_name" required>
              </div>
            </div>
          </div>
          <div class="mb-3">
            <div class="row">
              <div class="col">
                <label for="phone" class="form-label">Phone <span class="text-danger">*</span></label>
                <input type="number" class="form-control" [(ngModel)]="item.phone" id="phone" min="0" required>
              </div>
              <div class="col">
                <label for="phone2" class="form-label">Secondary Phone</label>
                <input type="number" class="form-control" [(ngModel)]="item.phone2" id="phone2" min="0">
              </div>
            </div>
          </div>
          <div class="mb-3">
            <label for="n_id" class="form-label">National ID</label>
            <input type="text" class="form-control" [(ngModel)]="item.national_id" id="n_id">
          </div>
          <div class="mb-3">
            <label for="email" class="form-label">Email</label>
            <input type="email" class="form-control" [(ngModel)]="item.email" id="email">
          </div>
          <div class="mb-3">
            <div class="row">
              <div class="col">
                <label for="gender" class="form-label">Gender</label>
                <select class="form-select" [(ngModel)]="item.gender" id="gender">
                  <option [value]='0'>Male</option>
                  <option [value]='1'>Female</option>
                </select>
              </div>
              <div class="col">
                <label for="birth_date" class="form-label">Birth Date <span class="text-danger">*</span></label>
                <input type="date" class="form-control" [(ngModel)]="item.birth_date" id="birth_date" required>
              </div>
            </div>
          </div>
          <div class="mb-3">
            <label for="address" class="form-label">Address</label>
            <textarea class="form-control" [(ngModel)]="item.address" id="address" rows="2"
            cols="50"></textarea>
          </div>
          <div class="mb-3">
            <label for="visiting_reason" class="form-label">Occupation </label>
            <textarea class="form-control" [(ngModel)]="item.visiting_reason" id="visiting_reason" rows="4"
            cols="50"></textarea>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-success" (click)="OnSumbit()" [disabled]="!isNewPatientFormValid">Add</button>
        </div>
      </ng-template>

      <ng-template #content2 let-modal>
        <div class="modal-header">
          <h4 class="modal-title" id="modal-basic-title">Edit Patient</h4>
          <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <div class="row">
              <div class="col">
                <label for="first_name" class="form-label">Name <span class="text-danger">*</span></label>
                <input type="text" class="form-control" [(ngModel)]="edit_item.first_name"
                  id="first_name" required>
              </div>
              <div class="col">
                <label for="last_name" class="form-label">Last Name <span class="text-danger">*</span></label>
                <input type="text" class="form-control" [(ngModel)]="edit_item.last_name"
                  id="last_name" required>
              </div>
            </div>
          </div>
          <div class="mb-3">
            <div class="row">
              <div class="col">
                <label for="phone" class="form-label">Phone <span class="text-danger">*</span></label>
                <input type="number" class="form-control" [(ngModel)]="edit_item.phone" id="phone" min="0" required>
              </div>
              <div class="col">
                <label for="phone2" class="form-label">Secondary Phone</label>
                <input type="number" class="form-control" [(ngModel)]="edit_item.phone2" id="phone2" min="0">
              </div>
            </div>
          </div>

          <div class="mb-3">
            <label for="n_id" class="form-label">National ID</label>
            <input type="text" class="form-control" [(ngModel)]="edit_item.national_id" id="n_id">
          </div>
          <div class="mb-3">
            <label for="email" class="form-label">Email</label>
            <input type="email" class="form-control" [(ngModel)]="edit_item.email" id="email">
          </div>
          <div class="mb-3">
            <div class="row">
              <div class="col">
                <label for="gender" class="form-label">Gender</label>
                <select class="form-select" [(ngModel)]="edit_item.gender" id="gender">
                  <option [value]='0'>Male</option>
                  <option [value]='1'>Female</option>
                </select>
              </div>
              <div class="col">
                <label for="birth_date" class="form-label">Birth Date <span class="text-danger">*</span></label>
                <input type="date" class="form-control" [(ngModel)]="edit_item.birth_date"
                  id="birth_date" required>
              </div>
            </div>
          </div>
          <div class="mb-3">
            <label for="address" class="form-label">Address</label>
            <textarea class="form-control" [(ngModel)]="edit_item.address" id="address" rows="2"
            cols="50"></textarea>
          </div>
          <div class="mb-3">
            <label for="visiting_reason" class="form-label">Occupation </label>
            <textarea class="form-control" [(ngModel)]="edit_item.visiting_reason" id="visiting_reason"
            rows="4" cols="50"></textarea>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-success" (click)="OnUpdate(patient_id)" [disabled]="!isEditPatientFormValid">Edit</button>
        </div>
      </ng-template>

      <ng-template #contentAppointment let-modal>
        <div class="modal-header">
          <h4 class="modal-title" id="modal-basic-title">New Appointment</h4>
          <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <div class="row">
              <div class="col">
                <label for="doctor_id" class="form-label">Clinician</label>
                <select class="form-select" [(ngModel)]="appointment.doctor_id"
                  (change)="getDoctorSlots()">
                  <option [ngValue]="null">-- SELECT --</option>
                  @for (doctor of doctors; track doctor) {
                    <option [ngValue]='doctor.id'>{{ doctor.name }}
                    </option>
                  }
                </select>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <label for="date" class="form-label">Date</label>
                <input type="datetime-local" class="form-control" id="date"
                  [(ngModel)]="appointment.date" [disabled]="appointment.doctor_id==null">
              </div>
            </div>
            <div class="row">
              <div class="col">
                <label class="form-label">Clinician Booked Slots</label>
                <div class="card">
                  <div class="card-body table-wrapper">
                    <table class="table">
                      <tr>
                        <td>date</td>
                        <td colspan="2">time</td>
                      </tr>
                      @for (slot of dateSelection(slots); track slot) {
                        <tr>
                          <td>{{slot.date_time | date:'dd/MM/yyyy'}}</td>
                          <td>{{slot.date_time | date:'hh:mm a'}}</td>
                          <td>{{slot.date_time_to | date:'hh:mm a'}}</td>
                        </tr>
                      }
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <label for="service" class="form-label">Type of Service</label>
                <select class="form-select" [(ngModel)]="appointment.service" (change)="getPrice()" [disabled]="appointment.patient_id==null">
                  <option [ngValue]="null">-- SELECT SERVICE --</option>
                  @for (service of services; track service) {
                    <option [ngValue]='service.id'>{{ service.name }}
                    </option>
                  }
                </select>
              </div>
              <div class="col">
                <label for="price" class="form-label">Price</label>
                <input type="number" class="form-control" [(ngModel)]="appointment.price" id="price"
                  disabled>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <label for="period" class="form-label">Appointment Period</label>
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="period" id="period30"
                    [(ngModel)]="appointment.period" [value]="30">
                  <label class="form-check-label" for="period30">
                    30 minutes
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="period" id="period60"
                    [(ngModel)]="appointment.period" [value]="60">
                  <label class="form-check-label" for="period60">
                    60 minutes
                  </label>
                </div>
              </div>
              <div class="col">
                <label for="period" class="form-label">- -</label>
                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" id="walkin"
                    [(ngModel)]="appointment.walkin">
                  <label class="form-check-label" for="walkin">Walk-in</label>
                </div>
                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" id="overbooked"
                    [(ngModel)]="appointment.overbooked">
                  <label class="form-check-label" for="overbooked">Over booked</label>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <label for="notes" class="form-label">Notes</label>
              <textarea class="form-control" [(ngModel)]="appointment.notes" id="notes" rows="2"
              cols="50"></textarea>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-success" (click)="createAppointment(contentPackage)" [disabled]="appointment.service==''">Add</button>
        </div>
      </ng-template>

      <ng-template #contentPackage let-modal>
        <div class="modal-header">
          <h4 class="modal-title" id="modal-basic-title">Select Package</h4>
          <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <div class="row">
              <div class="col">
                <p><b>Please Select Package type for payment if the payment is based on Installment, otherwise select No Package.</b></p>
              </div>
            </div>
          </div>
          <div class="mb-3">
            <div class="row">
              <div class="col">
                <label for="gender" class="form-label">Package Type</label>
                <select class="form-select" [(ngModel)]="package.package_id" (change)="onChangePackage()">
                  <option [ngValue]="null">-- No Package --</option>
                  @for (package of packages_list; track package) {
                    <option [ngValue]='package.id'>{{ package.name }}
                    </option>
                  }
                </select>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <label for="price" class="form-label">Number of Sessions</label>
                <input type="text" class="form-control" [(ngModel)]="package.no_sessions" id="price" disabled>
              </div>
              <div class="col">
                <label for="price" class="form-label">Price per Session</label>
                <input type="text" class="form-control" [(ngModel)]="package.session_price" id="price" disabled>
              </div>
              <div class="col">
                <label for="price" class="form-label">Total</label>
                <input type="text" class="form-control" [ngModel]="package.no_sessions * +package.session_price" id="price" disabled>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-success" (click)="OnSumbitPackage()">Confirm</button>
        </div>
      </ng-template>
    </div>
  </div>
</div>